"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _TemplateContainer = _interopRequireDefault(require("./TemplateContainer"));
var MoveContainer = /*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MoveContainer, _React$Component);
  function MoveContainer() {
    var _getPrototypeOf2;
    var _this;
    (0, _classCallCheck2.default)(this, MoveContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MoveContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_templateContainer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_templateContainerSetter", function (cmp) {
      if (cmp) _this._templateContainer = cmp;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_el", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_elSetter", function (el) {
      if (el) _this._el = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_dragHandle", function (el) {
      return _this.props.makeDragHandle(el, function () {
        return _this.props.y;
      });
    });
    return _this;
  }
  (0, _createClass2.default)(MoveContainer, [{
    key: "getDOMNode",
    value: function getDOMNode() {
      return this._el;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._templateContainer.getTemplate();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.y !== nextProps.y || this.props.height !== nextProps.height || this.props.zIndex !== nextProps.zIndex || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        item = _this$props.item,
        y = _this$props.y,
        padding = _this$props.padding,
        itemSelected = _this$props.itemSelected,
        anySelected = _this$props.anySelected,
        height = _this$props.height,
        zIndex = _this$props.zIndex,
        template = _this$props.template,
        commonProps = _this$props.commonProps;
      return _react.default.createElement("div", {
        ref: this._elSetter,
        style: {
          position: y == null ? 'relative' : 'absolute',
          boxSizing: 'border-box',
          left: '0px',
          right: '0px',
          top: y == null ? '0px' : "".concat(y, "px"),
          marginBottom: "".concat(padding, "px"),
          height: y == null ? 'auto' : "".concat(anySelected * (height.drag - height.natural) + height.natural, "px"),
          zIndex: zIndex
        }
      }, _react.default.createElement(_TemplateContainer.default, {
        ref: this._templateContainerSetter,
        item: item,
        template: template,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandle: this._dragHandle,
        commonProps: commonProps
      }));
    }
  }]);
  return MoveContainer;
}(_react.default.Component);
exports.default = MoveContainer;
module.exports = exports.default;
module.exports.default = exports.default;